// Цена в форме — в рублях, в контракте — в копейках.
export const MINOR_UNITS_IN_MAJOR = 100;

// Сумма из поля ввода — в копейки контракта. Запятая — обычный ввод с клавиатуры.
export const parseMajorAmount = (value: string): number | null => {
    const trimmed = value.trim().replace(",", ".");
    const amount = Number(trimmed);

    if (trimmed === "" || !Number.isFinite(amount) || amount <= 0) return null;

    return Math.round(amount * MINOR_UNITS_IN_MAJOR);
};

export const formatPrice = (price: number, currencyId: string): string =>
    `${(price / MINOR_UNITS_IN_MAJOR).toLocaleString("ru-RU")} ${currencyId}`;
